import { useNavigate } from 'react-router-dom'

import { AddWorkScheduleModalPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import AddWorkScheduleModal from 'modules/work_schedules/components/AddWorkScheduleModal'

const AddWorkScheduleModalPage = () => {
  const { navigation } = useNavigation()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, loading } = useQuery(AddWorkScheduleModalPageDocument, {
    variables: {
      companyId,
    },
  })

  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.workSchedule.fullPath())
  }

  const onSuccess = (id: number) => {
    navigate(navigation.settings.workSchedule.id.fullPath({ id }))
  }

  const hasFixedWorkSchedulesEnabled = data?.features.featuresConnection.nodes[0]?.enabled ?? false

  if (loading) {
    return <Loading />
  }
  return (
    <AuthorizeUser
      authorizeFn={() => data?.workSchedule?._policies?.manageCompanySchedules?.can ?? false}
    >
      <AddWorkScheduleModal
        onClose={onClose}
        onSuccess={onSuccess}
        hasFixedWorkSchedulesEnabled={hasFixedWorkSchedulesEnabled}
      />
    </AuthorizeUser>
  )
}

export default AddWorkScheduleModalPage
